import { Box } from '@flos/react-ui';
import { Outlet } from 'react-router-dom';
import { CSSProperties } from 'react';
import { RenderHtml } from '../components/shared/RenderHtml';

const sizes: Record<string, string> = {
    DEFAULT: 'default',
    MEDIUM: 'medium-width',
    SMALL: 'small-width',
    LARGE: 'large-width',
    XLARGE: 'xlarge-width'
};

interface Props {
    wrapperChildren?: JSX.Element;
    title?: string;
    size?: string;
    error?: boolean;
    titleStyle?: CSSProperties;
}

const PageComponentWrapper = ({ wrapperChildren, title, size, error, titleStyle }: Props): JSX.Element => {
    const widthClass = size ? sizes[size] : sizes['DEFAULT'];
    const getComponentWrapperBySize = (size?: string) => {
        size = size ?? 'default';

        switch (size.toUpperCase()) {
            case 'LARGE':
            case 'XLARGE':
                return <div className="u-spacing-stack-l">{wrapperChildren}</div>;
            default:
                return (
                    <Box className={`u-spacing-stack-l ${error ? 'box-error' : ''}`} padding="large">
                        {wrapperChildren}
                    </Box>
                );
        }
    };

    return (
        <>
            <div className={`page-component-wrapper page-component-wrapper--${widthClass}`}>
                {hasHtml(title ?? '') ? (
                    <RenderHtml>{title}</RenderHtml>
                ) : (
                    <h3 style={titleStyle ? titleStyle : undefined}>{title}</h3>
                )}
                {getComponentWrapperBySize(size)}
            </div>
            <Outlet />
        </>
    );
};

const PageNavigationWrapper = ({ wrapperChildren, size }: Props): JSX.Element => {
    const widthClass = size ? sizes[size] : sizes['DEFAULT'];
    return <div className={`page-navigation-wrapper page-navigation-wrapper--${widthClass}`}>{wrapperChildren}</div>;
};

const hasHtml = (str: string) => {
    const regexForHTML = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/;
    return regexForHTML.test(str);
};

export { PageComponentWrapper, PageNavigationWrapper };
